import React from 'react';
import { Reveal } from './Reveal';
import { benefits } from '../data/benefits';
export function BenefitsSection() {
  return <section className="bg-brand-alt px-4 py-20 md:py-24" data-id="element-23" data-mp="axh3bvdnh1e">
      <Reveal className="mx-auto max-w-5xl" data-id="element-24" data-mp="3iqgapkibdji8">
        <div className="mb-10 text-center" data-id="element-25" data-mp="3iporl95wle8u">
          <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-ocean" data-id="element-26" data-mp="3np1etv0osnby">TUTTO IN UN UNICO PERCORSO</p>
          <h2 className="text-3xl font-extrabold text-brand-deep md:text-4xl" data-id="element-27" data-mp="38ripork3k83z">Cosa contiene GEOGRAFIA PRONTA™</h2>
        </div>
        <div className="grid gap-5 sm:grid-cols-2" data-id="element-28" data-mp="3drwpjmbjobqx">
          {benefits.map(({
          emoji,
          title,
          description
        }) => <article key={title} className="flex flex-col rounded-2xl border border-brand-sand bg-brand-main p-7 text-left" data-id="element-29" data-mp="2zt6ra3czo60z">
              <span className="text-2xl" aria-hidden="true" data-id="element-30" data-mp="y10qj8dlot1k">
                {emoji}
              </span>
              <h3 className="mt-4 text-lg font-bold leading-snug text-brand-deep" data-id="element-31" data-mp="12y0u9cmz9jpi">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-brand-gray" data-id="element-32" data-mp="2be4b9x561p8f">{description}</p>
            </article>)}
        </div>
      </Reveal>
    </section>;
}